import React from "react";
import { useSelector } from "react-redux";

import { Backdrop, CircularProgress } from "@mui/material";

export const Loading = () => {
  const { loading } = useSelector((state) => state.loadingReducer);
  return (
    <Backdrop
      sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={loading}
    >
      <CircularProgress color="secondary" />
    </Backdrop>
  );
};
